import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function ModeratorSurprise({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 144"
      xmlSpace="preserve"
    >
      <g id="hécate">
        <g id="surprise_3_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.9977722"
            rx="72"
            ry="71.9977722"
          />
          <g>
            <defs>
              <ellipse
                id="SVGID_5_"
                cx="72"
                cy="72.0022278"
                rx="72"
                ry="71.9977722"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use
                xlinkHref="#SVGID_5_"
                overflow="visible"
              />
            </clipPath>
            <g
              id="profil_12_"
              clipPath="url(#SVGID_2_)"
            >
              <g>
                <g>
                  <g>
                    <path
                      fill="#0E0E11"
                      d="M74.2943497,17.1519489l-5.7435226,0.3199959l5.6299515,118.1100388l16.4894714-0.9187622 c14.2873154-0.7959595,24.7515106-13.7725143,22.5018539-27.9040146l-5.6750946-62.8325119 C104.9311523,27.8090038,90.5896378,16.2439938,74.2943497,17.1519489z"
                    />
                    <path
                      fill="#00AFEC"
                      d="M83.9871826,109.1728439c-6.2032242,4.0748215-7.9287338,12.4068298-3.8540421,18.6105499 c0.3263474,0.4968033,0.6891098,0.9539566,1.0665283,1.3926163l-0.0109863,0.0081329l35.0625229,41.1762238 l17.4956055-9.9151001l-31.1488419-47.4188538C98.52314,106.8231888,90.1906357,105.0975418,83.9871826,109.1728439z"
                    />
                    <circle
                      fill="#00AFEC"
                      cx="90.9897537"
                      cy="120.5569687"
                      r="13.8250828"
                    />
                    <path
                      fill="#00AFEC"
                      d="M104.7397156,121.196167l-3.5788879,77.3367615H51.7074394l-20.4364491-81.2171478 c-1.351881-5.3727417,2.7102489-10.583847,8.250597-10.583847h51.4078255 C98.8156662,106.7319336,105.1042709,113.3183136,104.7397156,121.196167z"
                    />
                    <path
                      fill="#00AFEC"
                      d="M49.2707596,110.2949295c-5.6673279-5.1163483-14.4092484-4.6697998-19.526123,0.9975281 c-0.4097538,0.4538879-0.7705879,0.9337234-1.1091976,1.4233475l-0.0109539-0.0088272l-33.1938095,48.0004807 l15.7276268,12.4359741l39.1105194-43.3222809C55.3851662,124.1538315,54.9386177,115.411377,49.2707596,110.2949295z"
                    />
                    <path
                      fill="#283042"
                      d="M107.0062637,58.086853c-0.0114822,0.0092049-0.0114822,0.0092049-0.0114822,0.0092049"
                    />
                    <path
                      fill="#D8A966"
                      d="M60.6811295,108.5916748c1.0414543,6.376236,7.0546188,10.7008286,13.4308548,9.6593781 c6.376236-1.0414581,10.7008286-7.0547333,9.6593781-13.4309692 c-1.0414581-6.3762283-7.0547333-10.7008209-13.4308548-9.6593704 C63.9642677,96.2021713,59.6395721,102.2154388,60.6811295,108.5916748z"
                    />
                    <polygon
                      fill="#D8A966"
                      points="83.7713623,104.8200836 60.6811295,108.5916748 56.0369682,80.1592255 56.7143936,80.0485764 79.1273041,76.3877411"
                    />
                    <path
                      fill="#D8A966"
                      d="M70.7297211,28.5487003l-1.7959824,0.2934093 c-11.462059,1.8721294-19.2361145,12.6816444-17.3638802,24.1435928l6.3857002,39.0949936l21.7395172-3.5509186 c10.9176712-1.7833252,18.3224869-12.0793991,16.5391617-22.9969635l-3.4501038-21.1228104 C91.0739746,33.9398422,81.1997757,26.8385372,70.7297211,28.5487003z"
                    />
                    <line
                      fill="none"
                      stroke="#0E0E11"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit="10"
                      x1="83.8197937"
                      y1="54.3666496"
                      x2="89.4302826"
                      y2="53.9403534"
                    />
                    <line
                      fill="none"
                      stroke="#0E0E11"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit="10"
                      x1="69.3179626"
                      y1="54.9886208"
                      x2="75.4080353"
                      y2="54.6191521"
                    />
                    <path
                      fill="#FDC9A3"
                      d="M52.2284431,68.7111435l4.77248-0.7760315l-0.7733536-4.7626724 c-0.4270935-2.6302986-2.9101028-4.4151306-5.5458145-3.986557l0,0 c-2.6357994,0.4285889-4.4262199,2.9084091-3.9990425,5.5386887l0,0 C47.1098251,67.35495,49.5927505,69.139801,52.2284431,68.7111435z"
                    />
                    <ellipse
                      transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.2610397 4.132215)"
                      fill="#0E0E11"
                      cx="72.5915451"
                      cy="60.6402893"
                      rx="1.585766"
                      ry="2.0463278"
                    />
                    <ellipse
                      transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.1975248 4.8912077)"
                      fill="#0E0E11"
                      cx="86.2561798"
                      cy="59.8789368"
                      rx="1.585766"
                      ry="2.0463278"
                    />
                    <path
                      fill="#0E0E11"
                      d="M60.3773232,106.7316971l-20.8557358,0.0002365L38.407917,47.2375717 c1.0215302-16.0830669,13.9028282-28.864563,29.9932899-29.7611351l0,0 c0.8272705-0.0460835,1.5469894,0.5608826,1.6411743,1.3840694l1.8399506,16.0815067 c0.0043716,0.0381927,0.0075684,0.0750122,0.009613,0.1133995 c0.3182297,5.9759407-1.9965744,15.9863892-4.8282318,21.2807083 c-0.0334473,0.0625381-5.4245949,8.7931976-5.4245949,8.7931976 c-1.4381714,2.0509872-2.372097,4.4169617-2.6662827,6.9046021 C57.2747421,86.3929672,60.3773232,106.7316971,60.3773232,106.7316971z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M65.3354721,27.9843369L77.3214798,39.905735 c4.2960739,4.2728577,10.2839661,6.3906097,16.3111649,5.7687759l0,0l1.1281281,10.9349136L92.996376,39.5074577 c-0.8105927-7.8565197-7.8366623-13.5684586-15.6931839-12.757864L65.3354721,27.9843369z"
                    />
                  </g>
                </g>
              </g>
              <g>
                <polygon
                  fill="#00AFEC"
                  points="131.7186584,169.8122101 161.526886,125.2936554 151.1636963,117.5870361 115.5539551,157.4331818"
                />
              </g>
            </g>
          </g>
          <ellipse
            fill="#FFFFFF"
            cx="83.0546646"
            cy="75.6331711"
            rx="1.8414383"
            ry="2.4704952"
          />
        </g>
      </g>
    </svg>
  );
}

export default ModeratorSurprise;
